module.exports = __webpack_public_path__ + "img/mute.e77a5d35.svg";